/* eslint-disable react-hooks/exhaustive-deps */
import React, { lazy, Suspense, useEffect, useRef, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  Card,
  Avatar,
  Typography,
  Divider,
  Row,
  Button,
  Col,
  Popconfirm,
  Modal,
  theme,
  message,
  Image,
  Input,
  Select,
} from "antd";
import {
  ScanOutlined,
  CheckSquareOutlined,
  BorderOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { useAuth } from "../../../AuthContext";
import GETDetalleAuditoria from "../../../helpers/auditoria/GETDetalleAuditoria";
import GETCodigoBarra from "../../../helpers/auditoria/GETCodigoBarra";
import POSTAgregarUbiManual from "../../../helpers/auditoria/POSTAgregarUbiManual";
import PUTConfirmarAuditoria from "../../../helpers/auditoria/PUTConfirmarAuditoria";
import { accionConfig } from "../../../utils/getAccionConfig";
import PUTIniciarAuditoria from "../../../helpers/auditoria/PUTIniciarAuditoria";
import PUTPausarAuditoria from "../../../helpers/auditoria/PUTPausarAuditoria";
import HeaderBack from "../../../components/layout/headers/HeaderBack";
import AppLayout from "../../../components/layout/AppLayout";
import Loader from "../../../components/loader/Loader";
import { getCardStyle } from "../../../utils/getCardStyle";
import PUTCompletarAuditoria from "../../../helpers/auditoria/PUTCompletarAuditoria";
import GETVerificarLoteVto from "../../../helpers/auditoria-sma/GETVerificarLoteVto";
import { formatVtoVisual } from "../../../utils/formatVtoVisual";
import {
  normalizarLote,
  normalizarVto,
} from "../../../utils/normalizarLoteVto";
import PUTConfirmarAuditoriaPalet from "../../../helpers/ordenes/PUTConfirmarAudPalet";
import PUTPaletRoyalCaninASA from "../../../helpers/auditoria/PUTPaletRoyalCaninASA";
import ManualBarcodeInput from "../../auditarSMA/detalleAuditoriaSMA/paletizado/lote/ManualBarcodeInput";
import { useAppVersionContext } from "../../../AppVersionContext";
import POSTSyncArticuloMultiplo from "../../../helpers/articulos/POSTSyncArticuloMultiplo";
import "./index.css";

const usaLote = process.env.REACT_APP_USALOTE;

const extraerMaterialCodeDeCb3 = (cb3) => {
  if (!cb3) return null;
  const clean = String(cb3).trim().replace(/[()]/g, "").toUpperCase();
  let pos = 0;
  if (clean.startsWith("00")) pos = 2;
  pos += 18;
  if (clean.slice(pos, pos + 3) === "240") pos += 3;
  return clean.slice(pos);
};

const esCodigoCB3Inventario = (codigo) => {
  const clean = String(codigo || "")
    .trim()
    .replace(/[()]/g, "");

  return /^00\d{18}240\d+$/i.test(clean);
};

const PaletCard = ({
  detalle,
  rango,
  darkMode,
  articuloCardRefs,
  ordenActiva,
  onResetCantidad,
  onConfirmPalet,
  onMultiploAplicado,
}) => {
  const refKey = `${rango.idubid}-palet-${detalle.idpale}`;

  const longPressTimer = useRef(null);

  const startLongPressConfirm = () => {
    longPressTimer.current = setTimeout(() => {
      onConfirmPalet(detalle);
    }, 500);
  };

  const startLongPressReset = () => {
    longPressTimer.current = setTimeout(() => {
      onResetCantidad(detalle);
    }, 500);
  };

  const clearLongPress = () => {
    if (longPressTimer.current) {
      clearTimeout(longPressTimer.current);
      longPressTimer.current = null;
    }
  };

  const handleMultiploChange = async (multip) => {
    const paletData = detalle?.palet || {};
    const sku = paletData.sku || detalle?.sku;
    const itemArticulo = (rango?.detalles ?? []).find(
      (d) =>
        d.articuloLogico &&
        String(d.articuloLogico.sku).trim() === String(sku).trim(),
    );
    const data = {
      idartl: paletData.idartl || itemArticulo?.articuloLogico?.id,
      matcod: extraerMaterialCodeDeCb3(paletData.cb3),
      multip,
    };

    if (!data.idartl || !data.matcod || !data.multip) {
      const faltan = [];
      if (!data.idartl) faltan.push("idartl");
      if (!data.matcod) faltan.push("matcod");
      if (!data.multip) faltan.push("multip");
      message.error(
        `Faltan datos para sincronizar el múltiplo: ${faltan.join(", ")}.`,
      );
      return;
    }

    const response = await POSTSyncArticuloMultiplo(
      data.idartl,
      data.matcod,
      data.multip,
    );
    if (response?.data?.result === false) {
      message.error(response.data.descri);
    } else if (response?.data?.result === true) {
      onMultiploAplicado?.(multip, detalle.idpale);
    }
  };

  return (
    <Col span={24} style={{ display: "flex" }}>
      <Card
        ref={(el) => (articuloCardRefs.current[refKey] = el)}
        hoverable
        styles={{ body: { padding: 16 } }}
        style={{
          ...getCardStyle(darkMode),
          height: "100%",
          flex: 1,
          transition: "background-color 0.3s ease",
          marginBottom: "8px",
        }}
      >
        <Row align="top" gutter={[8, 8]} justify="space-between">
          <div style={{ flex: 1 }}>
            <Text
              strong
              style={{
                fontSize: "20px",
                color: darkMode ? "white" : "black",
                marginBottom: "4px",
                display: "block",
              }}
            >
              #{detalle.palet?.idpale}
            </Text>

            <Text
              type="secondary"
              style={{
                fontSize: "15px",
                color: darkMode ? "white" : "black",
                display: "block",
              }}
            >
              {detalle?.palet?.descri}
            </Text>
          </div>

          <div style={{ textAlign: "right", minWidth: 120 }}>
            <Avatar
              src="/assets/palet.png"
              size={60}
              style={{
                backgroundColor: "#d5c279",
                marginTop: "8px",
              }}
            />
          </div>
        </Row>

        <Row justify="space-between" align="middle" style={{ marginTop: 12 }}>
          <Col>
            {ordenActiva &&
              (Number(detalle.cantidadAuditada) > 0 ? (
                <Button
                  type="text"
                  icon={
                    <CheckSquareOutlined
                      className="custom-icon"
                      style={{
                        fontSize: 36,
                        color: darkMode ? "white" : "black",
                      }}
                    />
                  }
                  onMouseDown={startLongPressReset}
                  onMouseUp={clearLongPress}
                  onMouseLeave={clearLongPress}
                  onTouchStart={startLongPressReset}
                  onTouchEnd={clearLongPress}
                />
              ) : (
                <Button
                  type="text"
                  icon={
                    <BorderOutlined
                      className="custom-icon"
                      style={{
                        fontSize: 36,
                        color: darkMode ? "white" : "black",
                      }}
                    />
                  }
                  onMouseDown={startLongPressConfirm}
                  onMouseUp={clearLongPress}
                  onMouseLeave={clearLongPress}
                  onTouchStart={startLongPressConfirm}
                  onTouchEnd={clearLongPress}
                />
              ))}
          </Col>

          <Col>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <Text
                strong
                type="secondary"
                style={{
                  fontSize: "20px",
                  color: darkMode ? "white" : "black",
                }}
              >
                {Math.round(Number(detalle.cantidadAuditada || 0))} Unid.
              </Text>

              {usaLote === "true" && ordenActiva && (
                <Select
                  defaultValue="x1"
                  style={{ width: 60 }}
                  options={Array.from({ length: 10 }, (_, i) => ({
                    label: `x${i + 1}`,
                    value: i + 1,
                  }))}
                  onChange={handleMultiploChange}
                />
              )}
            </div>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

const ArticuloCard = ({
  detalle,
  rango,
  darkMode,
  articuloCardRefs,
  ordenActiva,
  setModalVisible,
  auditoriaActual,
}) => {
  const articulo = detalle.articuloLogico;
  const articuloParte = detalle.articuloParte;

  const refKey = `${rango.idubid}-${articulo.sku}`;

  return (
    <Col span={24} style={{ display: "flex" }}>
      <Card
        ref={(el) => (articuloCardRefs.current[refKey] = el)}
        hoverable
        styles={{ body: { padding: 16 } }}
        style={{
          ...getCardStyle(darkMode),
          height: "100%",
          flex: 1,
          transition: "background-color 0.3s ease",
          marginBottom: "8px",
        }}
      >
        <Row align="top" gutter={[8, 8]} justify="space-between">
          <div style={{ flex: 1 }}>
            <Text
              strong
              style={{
                fontSize: "20px",
                color: darkMode ? "white" : "black",
                marginBottom: "4px",
                display: "block",
              }}
            >
              {articulo.sku}

              {articulo?.cantidadPartes > 1 && `-${articuloParte?.numeroParte}`}
            </Text>

            <Text
              type="secondary"
              style={{
                fontSize: "15px",
                color: darkMode ? "white" : "black",
                display: "block",
              }}
            >
              {articulo.nombre}
            </Text>

            {detalle?.articuloFisico?.valcar && (
              <Text
                type="secondary"
                style={{
                  fontSize: "15px",
                  color: darkMode ? "white" : "black",
                  display: "block",
                }}
              >
                {detalle.articuloFisico.valcar}
              </Text>
            )}

            <Text
              type="secondary"
              style={{
                fontSize: "15px",
                color: darkMode ? "white" : "black",
                display: "block",
              }}
            >
              {articulo.modelo}
            </Text>
          </div>

          <div style={{ textAlign: "right", minWidth: 120 }}>
            <Avatar
              src="/assets/producto.png"
              size={60}
              style={{
                backgroundColor: "#8f9ee0",
                marginTop: "8px",
              }}
            />
          </div>
        </Row>

        <Row justify="space-between" align="middle" style={{ marginTop: 12 }}>
          <Col>
            {ordenActiva && (
              <Image
                className="custom-icon"
                src={
                  darkMode ? "/icons/keyboard-white.png" : "/icons/keyboard.png"
                }
                preview={false}
                style={{
                  width: 40,
                  cursor: "pointer",
                  transition: "color 0.2s ease",
                }}
                onClick={(e) => {
                  const partes = detalle?.articuloLogico?.cantidadPartes;

                  const numeroParte = detalle?.articuloParte?.numeroParte;

                  e.stopPropagation();

                  setModalVisible({
                    status: true,
                    payload: {
                      ...auditoriaActual,
                      sku: detalle.articuloLogico.sku,
                      nombre: detalle.articuloLogico.nombre,
                      parte: partes > 1 ? numeroParte : 0,
                      modelo: detalle.articuloLogico.modelo,
                      ubicacion: detalle.ubicacion_id,
                      cantidad: detalle.cantidad,
                      valorInicial: detalle.cantidadAuditada,

                      idartp: detalle?.articuloParte?.id,
                      idartl: detalle?.articuloLogico?.id,
                      valcar: detalle?.articuloFisico?.valcar,
                    },
                  });
                }}
              />
            )}
          </Col>

          <Col>
            <Text
              strong
              type="secondary"
              style={{
                fontSize: "20px",
                color: darkMode ? "white" : "black",
              }}
            >
              {detalle.cantidadAuditada} Unid.
            </Text>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

const esInventario = process.env.REACT_APP_INVENTARIO === "true";

const ModalTecladoCantidad = lazy(
  () => import("../../../components/modalTecladoCantidad/ModalTecladoCantidad"),
);
const ModalTecladoAlfanumerico = lazy(
  () =>
    import("../../../components/modalTecladoAlfanumerico/ModalTecladoAlfanumerico"),
);

const { Text } = Typography;

const DetalleAuditoria = ({ darkMode, setDarkMode }) => {
  const { loggedUser } = useAuth();
  const ubicacionHeaderRefs = useRef({});
  const articuloCardRefs = useRef({});
  const ubicacionLongPressRef = useRef(null);
  const [articuloActivo, setArticuloActivo] = useState(null);

  const { token } = theme.useToken();

  const { idauds } = useParams();
  // const { idauds } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [auditoriaActual, setAuditoriaActual] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [procesandoAccion, setProcesandoAccion] = useState(false);
  const [valorTipeado, setValorTipeado] = useState("");
  const [ubicacionActiva, setUbicacionActiva] = useState(null);
  const [tecladoVisible, setTecladoVisible] = useState(false);
  const { usaModoLote } = useAppVersionContext();
  const [nombreArticulo, setNombreArticulo] = useState("");
  const [modalVisible, setModalVisible] = useState({
    status: false,
    payload: {},
  });

  const [modalPaletASA, setModalPaletASA] = useState({
    open: false,
    codigoOriginal: null,
  });

  const [modalLoteVtoVLX, setModalLoteVtoVLX] = useState({
    open: false,
    item: null,
    codigoOriginal: null,
    responseCodigo: null,
  });

  const [loteVLX, setLoteVLX] = useState("");
  const [vtoVLX, setVtoVLX] = useState("");

  const ordenActiva = auditoriaActual?.estadoOpe === "2";

  // efecto scroll a ubicación/artículo activo
  useEffect(() => {
    let targetElement = null;

    if (ubicacionActiva && articuloActivo?.idubid && articuloActivo?.sku) {
      const key = `${articuloActivo.idubid}-${articuloActivo.sku}`;
      if (articuloCardRefs.current[key]) {
        targetElement = articuloCardRefs.current[key];
      }
    }

    if (!targetElement && ubicacionActiva?.idubid) {
      targetElement = ubicacionHeaderRefs.current[ubicacionActiva.idubid];
    }

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [ubicacionActiva, articuloActivo]);

  const toggleUbicacion = (rango) => {
    if (ordenActiva) {
      setUbicacionActiva(
        ubicacionActiva?.idubid === rango.idubid ? null : rango,
      );
      setArticuloActivo(null);
    }
  };

  const startUbicacionLongPress = (rango) => {
    clearUbicacionLongPress();
    if (!ordenActiva) return;
    ubicacionLongPressRef.current = setTimeout(() => {
      toggleUbicacion(rango);
      ubicacionLongPressRef.current = null;
    }, 350);
  };

  const clearUbicacionLongPress = () => {
    if (ubicacionLongPressRef.current) {
      clearTimeout(ubicacionLongPressRef.current);
      ubicacionLongPressRef.current = null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await GETDetalleAuditoria(idauds);
        if (response?.data) {
          setAuditoriaActual(response.data);
        } else {
          setError("No se encontraron datos para esta auditoría");
        }
      } catch (err) {
        console.error("Error en fetchDetalle:", err);
        setError("Error al cargar los datos");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [idauds, loggedUser]);

  useEffect(() => {
    const handleKeyDown = async (e) => {
      if (!ordenActiva) return;

      // Modal abierto → scanner global apagado
      if (modalPaletASA?.open) return;

      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA")
        return;

      if (e.shiftKey && e.key === "T") {
        procesarCodigoVLX("0017790187009304848224060011245");
        return;
      }

      if (e.key === "Enter") {
        e.preventDefault();

        const codigo = valorTipeado.trim().toUpperCase();

        if (!codigo) {
          setUbicacionActiva(null);
          setArticuloActivo(null);
          setValorTipeado("");
          return;
        }

        try {
          await procesarCodigo(codigo);
        } catch (err) {
          console.error("Error en escaneo:", err);
          message.error("Error de conexión.");
        } finally {
          setValorTipeado("");
        }
      } else if (e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey) {
        const tecla = e.key === "!" && valorTipeado.length === 0 ? "#" : e.key;

        setValorTipeado((prev) => prev + tecla);
      } else if (e.key === "Backspace") {
        setValorTipeado((prev) => prev.slice(0, -1));
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    valorTipeado,
    loggedUser,
    auditoriaActual,
    ubicacionActiva,
    idauds,
    ordenActiva,
    modalPaletASA.open,
  ]);

  const procesarCodigoInventarioVLX = async ({ codigo, data = null }) => {
    if (!ubicacionActiva) {
      message.error("Primero debe activar una ubicación.");
      return true;
    }

    if (!esCodigoCB3Inventario(codigo)) {
      message.error(
        "En modo inventario debe leer el código de palet/artículo.",
      );
      return true;
    }

    if (data?.idpale) {
      const paletYaLeido = auditoriaActual?.rangos?.some((rango) =>
        rango.detalles?.some(
          (detalle) =>
            String(detalle?.idpale || "") === String(data.idpale) &&
            Number(detalle?.cantidadAuditada || 0) > 0,
        ),
      );

      if (paletYaLeido) {
        message.warning("Este palet ya fue leído.");
        return true;
      }

      const resConfirmar = await PUTConfirmarAuditoriaPalet(
        auditoriaActual.idOpe,
        data.idpale,
        ubicacionActiva.idubid,
        1,
      );

      if (resConfirmar?.status === 200) {
        const updated = await GETDetalleAuditoria(idauds);

        if (updated?.data) {
          setAuditoriaActual(updated.data);

          const mismaUbi = updated.data.rangos.find(
            (r) => String(r.idubid) === String(ubicacionActiva.idubid),
          );

          if (mismaUbi) {
            setUbicacionActiva(mismaUbi);
          }

          setArticuloActivo(null);

          // message.success(
          //   resConfirmar?.data?.descri || data?.descri || "Palet confirmado.",
          // );
        }
      } else {
        message.error(
          resConfirmar?.data?.message ||
            resConfirmar?.data?.descri ||
            "Error al confirmar palet.",
        );
      }

      return true;
    }

    setModalPaletASA({
      open: true,
      codigoOriginal: codigo,
    });

    return true;
  };

  const confirmarPaletASA = async ({ cb1, cb2, cb3 }) => {
    try {
      if (!ubicacionActiva) {
        message.error("Primero debe activar una ubicación.");
        return;
      }

      const res = await PUTPaletRoyalCaninASA(
        auditoriaActual.idOpe,
        cb1,
        cb2,
        cb3,
      );

      if (res?.status === 200 && res?.data?.result) {
        const idpaleCreado = res?.data?.codplt;

        if (!idpaleCreado) {
          message.error("El palet se creó pero no devolvió código.");
          return;
        }

        const resConfirmar = await PUTConfirmarAuditoriaPalet(
          auditoriaActual.idOpe,
          idpaleCreado,
          ubicacionActiva.idubid,
          1,
        );

        if (resConfirmar?.status === 200) {
          // message.success(
          //   resConfirmar?.data?.descri ||
          //     res?.data?.descri ||
          //     "Palet registrado.",
          // );

          setModalPaletASA({
            open: false,
            codigoOriginal: null,
          });

          const updated = await GETDetalleAuditoria(idauds);

          if (updated?.data) {
            setAuditoriaActual(updated.data);

            const mismaUbi = updated.data.rangos.find(
              (r) => String(r.idubid) === String(ubicacionActiva.idubid),
            );

            if (mismaUbi) {
              setUbicacionActiva(mismaUbi);
            }

            setArticuloActivo(null);
          }
        } else {
          message.error(
            resConfirmar?.data?.message ||
              resConfirmar?.data?.descri ||
              "El palet fue creado, pero no se pudo confirmar.",
          );
        }
      } else {
        message.error(
          res?.data?.message || res?.data?.descri || "Error al crear palet.",
        );
      }
    } catch (err) {
      console.error("Error creando/confirmando palet ASA:", err);
      message.error("Error de conexión.");
    }
  };

  const procesarCodigoVLX = async (codigo) => {
    const response = await GETCodigoBarra(
      codigo,
      auditoriaActual?.idOpe,
      false,
      false,
    );

    if (response?.status !== 200) {
      if (
        response?.status === 400 &&
        response?.data?.message === "Palet no encontrado"
      ) {
        setModalPaletASA({
          open: true,
          codigoOriginal: codigo,
        });

        return true;
      }

      message.error(response?.data?.message || "Código no válido.");
      return true;
    }

    const data = response.data;

    // 1) Ubicación
    if (data?.idubid) {
      const addUbiRes = await POSTAgregarUbiManual(
        idauds,
        data.idubid,
        loggedUser,
      );

      if (addUbiRes.status === 200 || addUbiRes.status === 201) {
        // message.success("Ubicación asignada correctamente");

        const updated = await GETDetalleAuditoria(idauds);

        if (updated?.data) {
          setAuditoriaActual(updated.data);

          const nuevaUbi = updated.data.rangos.find(
            (r) => String(r.idubid) === String(data.idubid),
          );

          if (nuevaUbi) {
            setUbicacionActiva(nuevaUbi);
            setArticuloActivo(null);
            // message.success(`Ubicación activa: ${nuevaUbi.etique}`);
          }
        }
      } else {
        message.error(addUbiRes.message || "No se pudo asignar la ubicación");
      }

      return true;
    }

    // 1.5) MODO INVENTARIO - reservado para caso especial
    if (esInventario && data?.idpale) {
      return await procesarCodigoInventarioVLX({
        codigo,
        data,
      });
    }

    // 2) Palet VLX
    if (data?.idpale) {
      if (!ubicacionActiva) {
        message.error("Primero debe activar una ubicación.");
        return true;
      }

      const res = await PUTConfirmarAuditoriaPalet(
        auditoriaActual.idOpe,
        data.idpale,
        ubicacionActiva.idubid,
        1,
      );

      if (res?.status === 200) {
        const updated = await GETDetalleAuditoria(idauds);

        if (updated?.data) {
          setAuditoriaActual(updated.data);

          const mismaUbi = updated.data.rangos.find(
            (r) => String(r.idubid) === String(ubicacionActiva.idubid),
          );

          if (mismaUbi) {
            setUbicacionActiva(mismaUbi);
          }

          setArticuloActivo(null);

          // message.success(
          //   res?.data?.descri || "Palet registrado correctamente.",
          // );
        }
      } else {
        message.error(
          res?.data?.message || res?.message || "Error al registrar palet.",
        );
      }

      return true;
    }

    // 2) Artículo VLX: exige ubicación activa y abre modal lote/vto
    // 2) Artículo VLX con lote/vto obligatorio
    if (data?.idtipa === "04") {
      if (!ubicacionActiva) {
        message.error("Primero debe activar una ubicación.");
        return true;
      }

      const detalle = auditoriaActual.rangos
        .flatMap((rango) => rango.detalles)
        .find((d) =>
          data.idartl
            ? d.articuloLogico?.id === data.idartl
            : d.idpale === data.idpale,
        );

      const descripcion =
        detalle?.articuloLogico?.nombre ?? detalle?.palet?.descri ?? "";

      setNombreArticulo(descripcion);

      setModalLoteVtoVLX({
        open: true,
        item: data,
        codigoOriginal: codigo,
        responseCodigo: data,
      });

      return true;
    }

    // 3) Artículo normal
    if (data?.idartp) {
      if (!ubicacionActiva) {
        message.error("Primero debe activar una ubicación.");
        return true;
      }

      const payload = {
        idoaudope: auditoriaActual.idOpe,
        idartp: data.idartp,
        idubid: ubicacionActiva.idubid,
        cantidad: 1,
        esLecturaCodBarras: true,
      };

      const res = await PUTConfirmarAuditoria(payload);

      if (res?.status === 200) {
        const updated = await GETDetalleAuditoria(idauds);

        if (updated?.data) {
          setAuditoriaActual(updated.data);

          const mismaUbi = updated.data.rangos.find(
            (r) => r.idubid === ubicacionActiva.idubid,
          );

          if (mismaUbi) setUbicacionActiva(mismaUbi);

          setArticuloActivo({
            idubid: ubicacionActiva.idubid,
            sku: data.sku || "",
          });

          // message.success("Artículo registrado.");
        }
      } else {
        message.error(res?.data?.message || "Error al registrar.");
      }

      return true;
    }

    message.error("Código no reconocido.");
    return true;
  };

  const procesarCodigo = async (codigoRaw) => {
    if (!ordenActiva) return;

    const codigo = String(codigoRaw || "")
      .trim()
      .toUpperCase();

    if (!codigo) {
      setUbicacionActiva(null);
      setArticuloActivo(null);
      return;
    }

    try {
      if (usaModoLote === "true") {
        const procesadoVLX = await procesarCodigoVLX(codigo);
        if (procesadoVLX) return;
      }
      const rangoExistente = auditoriaActual?.rangos?.find(
        (r) => r.codigo === codigo || r.etique === codigo,
      );

      if (rangoExistente) {
        setUbicacionActiva(rangoExistente);
        setArticuloActivo(null);

        // message.success(`Ubicación activa: ${rangoExistente.etique}`);
        return;
      }

      const response = await GETCodigoBarra(codigo, auditoriaActual?.idOpe);
      if (response?.status !== 200) {
        message.error(response?.data?.message || "Código no válido.");
        return;
      }

      const data = response.data;

      if (data?.idubid) {
        const addUbiRes = await POSTAgregarUbiManual(
          idauds,
          data.idubid,
          loggedUser,
        );
        if (addUbiRes.status === 200 || addUbiRes.status === 201) {
          // message.success("Ubicación asignada correctamente");
          const updated = await GETDetalleAuditoria(idauds);
          if (updated?.data) {
            setAuditoriaActual(updated.data);
            const nuevaUbi = updated.data.rangos.find(
              (r) => r.idubid === data.idubid.toString(),
            );
            if (nuevaUbi) {
              setUbicacionActiva(nuevaUbi);
              setArticuloActivo(null);
              // message.success(`Ubicación agregada: ${nuevaUbi.etique}`);
            }
          }
        } else {
          message.error("No se pudo asignar la ubicación");
        }
      } else if (data?.idartp) {
        if (!ubicacionActiva) {
          message.error("Primero debe activar una ubicación.");
          return;
        }

        const payload = {
          idoaudope: auditoriaActual.idOpe,
          idartp: data.idartp,
          idubid: ubicacionActiva.idubid,
          cantidad: 1,
          esLecturaCodBarras: true,
        };

        const res = await PUTConfirmarAuditoria(payload);
        if (res?.status === 200) {
          const updated = await GETDetalleAuditoria(idauds);
          if (updated?.data) {
            setAuditoriaActual(updated.data);
            const mismaUbi = updated.data.rangos.find(
              (r) => r.idubid === ubicacionActiva.idubid,
            );
            if (mismaUbi) setUbicacionActiva(mismaUbi);

            setArticuloActivo({
              idubid: ubicacionActiva.idubid,
              sku: data.sku || "",
            });

            // message.success("Artículo registrado.");
          }
        } else {
          message.error(res?.data?.message || "Error al registrar.");
        }
      } else {
        message.error("Código no reconocido.");
      }
    } catch (err) {
      console.error("Error al procesar código:", err);
      message.error("Error de conexión.");
    }
  };

  const abrirTeclado = () => {
    setTecladoVisible(true);
  };

  const manejarConfirmacionTeclado = (valor) => {
    setTecladoVisible(false);
    procesarCodigo(valor);
  };

  const handleAccion = async () => {
    if (procesandoAccion) return;
    const accion = accionConfig[auditoriaActual.estadoOpe];
    if (!accion) return;

    let response;
    setProcesandoAccion(true);
    try {
      if (auditoriaActual?.estadoOpe === "1") {
        response = await PUTIniciarAuditoria(auditoriaActual.idOpe);
      } else {
        response = await PUTPausarAuditoria(
          auditoriaActual.idOpe,
          accion.accion,
        );
      }

      if (response?.status === 200) {
        const nuevoEstado = accion.accion ? "4" : "2";
        setAuditoriaActual((prev) => ({ ...prev, estadoOpe: nuevoEstado }));
        // message.success(
        //   response.data?.descri || "Estado actualizado correctamente.",
        // );
      } else {
        message.error(
          response?.data?.message || "No se pudo actualizar el estado.",
        );
      }
    } catch (err) {
      console.error("Error al cambiar estado:", err);
      message.error("Error al comunicarse con el servidor.");
    } finally {
      setProcesandoAccion(false);
    }
  };

  const accionActual = auditoriaActual
    ? accionConfig[auditoriaActual.estadoOpe] || null
    : null;

  const confirmOpenRef = useRef(false);

  const getParentPath = () => {
    const segments = location.pathname.split("/").filter(Boolean);

    if (segments.length > 1) {
      segments.pop();
      return "/" + segments.join("/");
    }

    return null;
  };

  const handleGoBack = () => {
    if (confirmOpenRef.current) return;

    const parentPath = getParentPath();

    const goBack = () => {
      if (parentPath) {
        navigate(parentPath);
      } else {
        navigate(-1);
      }
    };

    if (ordenActiva) {
      confirmOpenRef.current = true;

      Modal.confirm({
        title: "¿Seguro que deseas salir?",
        content: "Estás a punto de salir sin completar la auditoría.",
        okText: "Sí, salir",
        okType: "danger",
        cancelText: "Cancelar",
        onOk() {
          confirmOpenRef.current = false;
          goBack();
        },
        onCancel() {
          confirmOpenRef.current = false;
        },
      });
    } else {
      goBack();
    }
  };

  const headerComponent = (
    <HeaderBack
      modulo={"Mis Auditorias"}
      onBack={handleGoBack}
      data={{ headerTitle: auditoriaActual?.numeroComprobanteSMA }}
      acciones={
        <div style={{ display: "flex", gap: 12 }}>
          {ordenActiva && (
            <span
              onClick={abrirTeclado}
              style={{ cursor: "pointer", display: "flex" }}
            >
              <ScanOutlined style={{ fontSize: "36px", color: "white" }} />
            </span>
          )}
          <span
            onClick={handleAccion}
            style={{
              cursor: procesandoAccion ? "default" : "pointer",
              display: "flex",
              pointerEvents: procesandoAccion ? "none" : "auto",
              opacity: procesandoAccion ? 0.6 : 1,
            }}
          >
            {procesandoAccion ? (
              <SyncOutlined spin style={{ fontSize: "36px", color: "white" }} />
            ) : (
              accionActual?.icon
            )}
          </span>
        </div>
      }
    />
  );

  const handleConfirmModal = async (itemActualizado) => {
    const { valorFinal, sku, idartp } = itemActualizado;
    const skuBuscado = sku;

    if (usaModoLote === "true") {
      if (!ubicacionActiva) {
        message.error("Primero debe activar una ubicación.");
        return;
      }

      if (!idartp) {
        message.error("No se pudo determinar el artículo/lote a confirmar.");
        return;
      }

      const payloadOma = {
        idoaudope: auditoriaActual?.idOpe,
        idartp,
        idubid: ubicacionActiva.idubid,
        cantidad: valorFinal,
        esLecturaCodBarras: false,
      };

      const res = await PUTConfirmarAuditoria(payloadOma);

      if (res && res.status === 200) {
        const response = await GETDetalleAuditoria(idauds);

        if (response?.data) {
          setAuditoriaActual(response.data);
          setModalVisible({ status: false, payload: {} });
        } else {
          setError("No se encontraron datos para esta auditoría");
        }
      } else {
        message.error(res?.data?.message);
      }

      return;
    }

    const detalleDelRangoTrabajado = itemActualizado?.rangos.filter(
      (x) => x.idubid === ubicacionActiva.idubid,
    );

    const resultado = detalleDelRangoTrabajado
      .flatMap((ubicacion) => ubicacion.detalles)
      .find((det) => det.articuloLogico?.sku === skuBuscado);

    const partes = resultado?.articuloLogico?.cantidadPartes;
    const numeroParte = resultado?.articuloParte?.numeroParte;

    const skuCompleto = partes > 1 ? `${skuBuscado}${numeroParte}` : skuBuscado;

    const response = await GETCodigoBarra(skuCompleto);

    const payloadOma = {
      idoaudope: auditoriaActual?.idOpe,
      idartp: response?.data?.idartp,
      idubid: ubicacionActiva.idubid,
      cantidad: valorFinal,
      esLecturaCodBarras: false,
    };
    const res = await PUTConfirmarAuditoria(payloadOma);
    if (res && res.status === 200) {
      const response = await GETDetalleAuditoria(idauds);
      if (response?.data) {
        setAuditoriaActual(response.data);
        setModalVisible({ status: false, payload: {} });
      } else {
        setError("No se encontraron datos para esta auditoría");
      }
    } else {
      message.error(res?.data?.message);
    }
  };

  const confirmarLoteVtoVLX = async () => {
    const item = modalLoteVtoVLX.item;

    if (!item) return;

    if (!loteVLX || !vtoVLX) {
      message.error("Debe ingresar lote y vencimiento.");
      return;
    }

    if (!ubicacionActiva) {
      message.error("Primero debe activar una ubicación.");
      return;
    }

    try {
      const respLote = await GETVerificarLoteVto(loteVLX, item.idartl, vtoVLX);

      if (
        respLote?.data?.codres === "1" &&
        respLote?.data?.result === "false"
      ) {
        message.error(respLote.data?.descri || "Error validando lote.");
        return;
      }

      const idartpFinal = respLote?.data?.idartp || item.idartp;

      if (!idartpFinal) {
        message.error("No se pudo determinar el artículo/lote a confirmar.");
        return;
      }

      const payload = {
        idoaudope: auditoriaActual.idOpe,
        idartp: idartpFinal,
        idubid: ubicacionActiva.idubid,
        cantidad: 1,
        esLecturaCodBarras: true,
      };

      const res = await PUTConfirmarAuditoria(payload);

      if (res?.status === 200) {
        const updated = await GETDetalleAuditoria(idauds);

        if (updated?.data) {
          setAuditoriaActual(updated.data);

          const mismaUbi = updated.data.rangos.find(
            (r) => String(r.idubid) === String(ubicacionActiva.idubid),
          );

          if (mismaUbi) setUbicacionActiva(mismaUbi);

          setArticuloActivo({
            idubid: ubicacionActiva.idubid,
            sku: item.sku || item.codigo || "",
          });

          setModalLoteVtoVLX({
            open: false,
            item: null,
            codigoOriginal: null,
            responseCodigo: null,
          });

          setNombreArticulo("");
          setLoteVLX("");
          setVtoVLX("");

          // message.success(respLote?.data?.descri || "Artículo registrado.");
        }
      } else {
        message.error(res?.data?.message || "Error al registrar.");
      }
    } catch (err) {
      console.error("Error confirmando lote/vto VLX:", err);
      message.error("Error validando lote/vto.");
    }
  };

  const onConfirmPalet = async (detalle) => {
    try {
      if (!ubicacionActiva) {
        message.error("Primero debe activar una ubicación.");
        return;
      }

      const res = await PUTConfirmarAuditoriaPalet(
        auditoriaActual.idOpe,
        detalle.idpale,
        ubicacionActiva.idubid,
        1,
      );

      if (res?.status === 200) {
        const updated = await GETDetalleAuditoria(idauds);

        if (updated?.data) {
          setAuditoriaActual(updated.data);

          const mismaUbi = updated.data.rangos.find(
            (r) => String(r.idubid) === String(ubicacionActiva.idubid),
          );

          if (mismaUbi) {
            setUbicacionActiva(mismaUbi);
          }

          // message.success(res?.data?.descri || "Palet confirmado.");
        }
      } else {
        message.error(res?.data?.message || "Error al confirmar palet.");
      }
    } catch (err) {
      console.error("Error confirmando palet:", err);
      message.error("Error de conexión.");
    }
  };

  const onResetCantidad = async (detalle) => {
    try {
      if (!ubicacionActiva) {
        message.error("Primero debe activar una ubicación.");
        return;
      }

      const res = await PUTConfirmarAuditoriaPalet(
        auditoriaActual.idOpe,
        detalle.idpale,
        ubicacionActiva.idubid,
        0,
      );

      if (res?.status === 200) {
        const updated = await GETDetalleAuditoria(idauds);

        if (updated?.data) {
          setAuditoriaActual(updated.data);

          const mismaUbi = updated.data.rangos.find(
            (r) => String(r.idubid) === String(ubicacionActiva.idubid),
          );

          if (mismaUbi) {
            setUbicacionActiva(mismaUbi);
          }

          // message.success(res?.data?.descri || "Palet reiniciado.");
        }
      } else {
        message.error(res?.data?.message || "Error al reiniciar palet.");
      }
    } catch (err) {
      console.error("Error reiniciando palet:", err);
      message.error("Error de conexión.");
    }
  };

  const handleMultiploAplicado = (multip, idpale) => {
    const factor = Number(multip) || 1;
    setAuditoriaActual((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        rangos: prev.rangos.map((rango) => ({
          ...rango,
          detalles: rango.detalles.map((d) => {
            if (d.idpale !== idpale) return d;
            const multiploGuardado = Number(d.multiploAplicado ?? 1);
            const base = Number(d.cantidadAuditada ?? 0) / multiploGuardado;
            return {
              ...d,
              cantidadAuditada: base * factor,
              multiploAplicado: factor,
            };
          }),
        })),
      };
    });
  };

  return (
    <AppLayout
      darkMode={darkMode}
      setDarkMode={setDarkMode}
      header={headerComponent}
    >
      {loading && <Loader />}

      {auditoriaActual?.rangos?.length === 0 && (
        <Col
          span={24}
          style={{
            position: "sticky",
            top: -10,
            zIndex: 10,
            padding: 0,
            backgroundColor: darkMode ? "#222" : "#fafafa",
            color: darkMode ? "#fff" : "#000",
            borderRadius: 6,
          }}
        >
          <div className="ubi-wrapper">
            <Typography.Title level={4} className="ubi-text">
              No ha escaneado ninguna ubicación.
            </Typography.Title>
          </div>
        </Col>
      )}

      {!error && auditoriaActual && (
        <div
          style={{
            height: "calc(100vh - 120px)",
            padding: "8px",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {auditoriaActual?.rangos?.map((rango) => (
            <React.Fragment key={rango.etique}>
              {/* Cabecera de ubicación con ref */}
              <Col span={24}>
                <div
                  ref={(el) => (ubicacionHeaderRefs.current[rango.idubid] = el)}
                  className="ubi-wrapper"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "8px",
                    borderRadius: "6px",
                    backgroundColor:
                      ubicacionActiva?.idubid === rango.idubid
                        ? "#cfe8d6"
                        : "#5d5b5b",
                    border: `1px solid ${darkMode ? "#333" : "#eee"}`,
                    cursor: ordenActiva ? "pointer" : "default",
                  }}
                  onMouseDown={() => startUbicacionLongPress(rango)}
                  onMouseUp={clearUbicacionLongPress}
                  onMouseLeave={clearUbicacionLongPress}
                  onTouchStart={() => startUbicacionLongPress(rango)}
                  onTouchEnd={clearUbicacionLongPress}
                  onTouchCancel={clearUbicacionLongPress}
                >
                  <Typography.Title
                    level={4}
                    style={{
                      margin: 0,
                      color: "#000",
                    }}
                  >
                    {rango.etique}
                    {rango.detalles?.length > 0 && (
                      <span
                        style={{
                          marginLeft: 8,
                          fontSize: "15px",
                          opacity: 0.8,
                        }}
                      >
                        ({rango.detalles.length})
                      </span>
                    )}
                  </Typography.Title>
                </div>
              </Col>

              {/* Mostrar artículos solo si: */}
              {/* - NO estamos en modo activo, O */}
              {/* - la ubicación está activa */}
              {(ordenActiva === false ||
                ubicacionActiva?.idubid === rango.idubid) &&
                rango.detalles?.map((detalle) => {
                  const esPalet = !!detalle?.idpale && !detalle?.articuloLogico;

                  return esPalet ? (
                    <PaletCard
                      key={`palet-${detalle.idpale}`}
                      detalle={detalle}
                      rango={rango}
                      darkMode={darkMode}
                      articuloCardRefs={articuloCardRefs}
                      ordenActiva={ordenActiva}
                      onResetCantidad={onResetCantidad}
                      onConfirmPalet={onConfirmPalet}
                      onMultiploAplicado={handleMultiploAplicado}
                    />
                  ) : (
                    <ArticuloCard
                      key={`art-${detalle.articuloLogico?.sku}`}
                      detalle={detalle}
                      rango={rango}
                      darkMode={darkMode}
                      articuloCardRefs={articuloCardRefs}
                      ordenActiva={ordenActiva}
                      setModalVisible={setModalVisible}
                      auditoriaActual={auditoriaActual}
                    />
                  );
                })}
            </React.Fragment>
          ))}

          {ordenActiva && (
            <>
              <Divider style={{ margin: 6 }} />
              <div
                style={{
                  width: "100%",
                  height: "50px",
                  fontSize: "17px",
                  fontWeight: 500,
                  borderRadius: token.borderRadiusLG,
                  marginTop: "8px",
                }}
              >
                <Popconfirm
                  title="Confirmar acción"
                  okText="Sí"
                  cancelText="No"
                  onConfirm={async () => {
                    const res = await PUTCompletarAuditoria(
                      auditoriaActual.idOpe,
                    );
                    if (res && res.status === 200) {
                      // message.success(
                      //   res?.data?.descri || "Auditoría completada con éxito.",
                      // );
                      navigate(-1);
                    } else {
                      message.error(
                        res?.data?.message ||
                          "Error al completar la auditoría.",
                      );
                    }
                  }}
                >
                  <Button block size="large" type="primary">
                    Completar auditoria
                  </Button>
                </Popconfirm>
              </div>
            </>
          )}
        </div>
      )}

      {modalVisible?.status && (
        <Suspense fallback={null}>
          <ModalTecladoCantidad
            darkMode={darkMode}
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            onConfirm={handleConfirmModal}
          />
        </Suspense>
      )}

      {tecladoVisible && (
        <Suspense fallback={null}>
          <ModalTecladoAlfanumerico
            open={tecladoVisible}
            onClose={() => setTecladoVisible(false)}
            darkMode={darkMode}
            letras={["A", "B", "C", "J", "P", "#"]} // OTERO
            // letras={["A", "B", "C", "D", "P", "#"]} // OTROS
            onConfirm={manejarConfirmacionTeclado}
            title="Ingrese ubicación o código"
          />
        </Suspense>
      )}

      <Modal
        destroyOnHidden={true}
        open={modalLoteVtoVLX.open}
        // title="Ingresar Lote y VTO"
        title={
          <div>
            <div>Ingresar Lote y VTO</div>
            {nombreArticulo && (
              <div style={{ fontSize: 14, fontWeight: "normal", opacity: 0.7 }}>
                {nombreArticulo}
              </div>
            )}
          </div>
        }
        okText="Confirmar"
        cancelText="Cancelar"
        onCancel={() => {
          setModalLoteVtoVLX({
            open: false,
            item: null,
            codigoOriginal: null,
            responseCodigo: null,
          });
          setLoteVLX("");
          setVtoVLX("");
        }}
        onOk={confirmarLoteVtoVLX}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
            marginTop: 8,
          }}
        >
          <Input
            placeholder="Lote"
            value={loteVLX}
            onChange={(e) => setLoteVLX(normalizarLote(e.target.value))}
            maxLength={25}
          />

          <Input
            placeholder="Vencimiento (YYYY-MM-DD)"
            value={formatVtoVisual(vtoVLX)}
            onChange={(e) => setVtoVLX(normalizarVto(e.target.value))}
            maxLength={10}
          />
        </div>
      </Modal>

      <Modal
        destroyOnHidden
        open={modalPaletASA.open}
        title="Registrar palet"
        footer={null}
        onCancel={() =>
          setModalPaletASA({
            open: false,
            codigoOriginal: null,
          })
        }
      >
        <ManualBarcodeInput
          darkMode={darkMode}
          initialCode={modalPaletASA.codigoOriginal}
          onCancel={() =>
            setModalPaletASA({
              open: false,
              codigoOriginal: null,
            })
          }
          onConfirm={confirmarPaletASA}
        />
      </Modal>
    </AppLayout>
  );
};

export default DetalleAuditoria;
